import React from 'react';
const BigDataSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-bigData" });
BigDataSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-bigData sirius-icon-bigData-enhance" });
export default BigDataSvg;
